import React from 'react';
import { CircleDotIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function FinalCTASection() {
  return <section className="bg-tr-navy px-5 py-16 text-center md:py-24" data-id="element-80" data-mp="3n4wd2apgovo7">
      <Reveal className="mx-auto max-w-2xl" data-id="element-81" data-mp="3s2pjn4uofrp0">
        <span className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10" data-id="element-82" data-mp="vlaa3b27tdf">
          <CircleDotIcon className="h-6 w-6 text-[#D8F35B]" strokeWidth={1.75} aria-hidden="true" data-id="element-83" data-mp="2zdqtbkgehj8m" />
        </span>
        <h2 className="mt-6 text-[2rem] font-bold leading-[1.12] tracking-tight text-white md:text-[3rem]" data-id="element-84" data-mp="34ahbqefogqx7">
          Ready to Bring Tennis to
          <br className="hidden sm:block" data-id="element-85" data-mp="3e2wuvf2pnljo" /> Every Court and Every Class?
        </h2>
        <p className="mx-auto mt-5 max-w-lg text-[15px] leading-relaxed text-white/80 md:text-base" data-id="element-86" data-mp="2gn96fwi91hv6">
          Start your season with every lesson, drill, assessment and progress
          report already written.
        </p>
        <CTAButton className="mt-9" data-id="element-87" data-mp="26vaghzk7vwwv" />
        <p className="mt-5 text-[11px] text-white/60" data-id="element-88" data-mp="26u915iw64o9c">
          Instant access · 30-day money-back guarantee
        </p>
      </Reveal>
    </section>;
}